import Suggestions from './model';
import create from './create';

Suggestions.create = create;

export default Suggestions;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/Idp/Suggestions/index.js